// noinspection SpellCheckingInspection

import bancoDoBrasilLogo from '@images/banks/banco-do-brasil.png'
import bancoDoEstadoLogo from '@images/banks/bank-banrisul.png'
import itauUnibancoLogo from '@images/banks/bank-itau-bba.png'
import bancoBradescoLogo from '@images/banks/banko-bradesco.png'
import cn from 'classnames'
import { tr } from 'mmfintech-commons'
import styles from './SelectDirectBankBrazil.module.scss'
import type { ISelectBankProps } from './SelectDirectBankBrazil.types.ts'

const BANKS = [
  {
    swiftCode: 'BBDEBRSPSPO',
    bankName: 'Banco Bradesco S/a',
    logo: bancoBradescoLogo,
    enabled: false
  },
  {
    swiftCode: 'BRASBRRJXXX',
    bankName: 'Banco Do Brasil S/a',
    logo: bancoDoBrasilLogo,
    enabled: true
  },
  {
    swiftCode: 'ITAUBRSPXXX',
    bankName: 'Itau Unibanco S/a',
    logo: itauUnibancoLogo,
    enabled: true
  },
  {
    swiftCode: 'BRGSBRRSXXX',
    bankName: 'Banco Do Estado Do Rio Grande Do Sul S/a',
    logo: bancoDoEstadoLogo,
    enabled: false
  }
]

export const SelectDirectBankBrazil = ({ bankCode, setBankCode }: ISelectBankProps) => {
  return (
    <>
      <div className='label'>{tr('FRONTEND.DEPOSIT.SELECT_BANK', 'Select Bank')}</div>

      <div className={cn(styles['select-bank-wrapper'], 'select-bank-wrapper', 'banks-container')}>
        {BANKS.filter(v => v.enabled).map(bank => (
          <div
            className={cn(styles['bank-radio-wrapper'], 'bank-radio-wrapper', {
              selected: bankCode === bank.swiftCode
            })}
            key={bank.swiftCode}
          >
            <div
              className={cn(styles['bank-radio-inner'], 'bank-radio-inner')}
              onClick={() => setBankCode(bank.swiftCode)}
            >
              <span>{bank.bankName}</span>
              {bank.logo && <img src={bank.logo} alt={bank.bankName} className='logo' />}
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
